import { memo } from "react";
import { Input, SelectInput } from "@repo/ui";

type FormData = {
  name: string;
  customerId: number | null;
  workflowId: number | null;
};

type Props = {
  mode: "create" | "edit";
  formData: FormData;
  customerOptions: { value: string; label: string }[];
  workflowOptions: { value: string; label: string }[];
  customersLoading: boolean;
  workflowsLoading: boolean;
  onCustomerChange: (value: string | string[] | undefined) => void;
  onWorkflowChange: (value: string | string[] | undefined) => void;
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const ListFormFields = memo<Props>(
  ({
    mode,
    formData,
    customerOptions,
    workflowOptions,
    customersLoading,
    workflowsLoading,
    onCustomerChange,
    onWorkflowChange,
    onNameChange,
  }) => {
    return (
      <div className="space-y-4">
        <SelectInput
          label="Customer"
          value={formData.customerId?.toString() || ""}
          onChange={onCustomerChange}
          disabled={customersLoading || mode === "edit"}
          placeholder={customersLoading ? "Loading customers..." : "Select a customer (optional)"}
          options={customerOptions}
        />

        <SelectInput
          label="Workflow"
          value={formData.workflowId?.toString() || ""}
          onChange={onWorkflowChange}
          disabled={workflowsLoading || mode === "edit"}
          placeholder={workflowsLoading ? "Loading workflows..." : "Select a workflow"}
          required
          options={workflowOptions}
        />

        <Input
          label="List Name"
          id="name"
          value={formData.name}
          onChange={onNameChange}
          placeholder="Enter list name"
          required
        />
      </div>
    );
  }
);

ListFormFields.displayName = "ListFormFields";
